import { Input, OnInit, inject, Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { Post } from 'src/app/core/models/core.models';

import { AppState } from 'src/app/reducers';
import { selectPostById, selectPostLoading } from 'src/app/core/reducers';

import { tap, switchMap, Observable, ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-post-video',
    templateUrl: './post-video.component.html',
    styleUrls: ['./post-video.component.scss'],
    standalone: false
})
export class PostVideoComponent implements OnInit {
  @Input() set postId(id: string) {
    this.postId$.next(id);
  }

  post$: Observable<Post>;
  postLoading$: Observable<boolean>;
  videos: { href: string; type: string }[] = [];

  private postId$ = new ReplaySubject<string>(1);
  private destroyRef = inject(DestroyRef);

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.postId$
      .pipe(
        tap((id) => {
          this.post$ = this.store.select(selectPostById(id));
          this.postLoading$ = this.store.select(selectPostLoading(id));
        }),
        switchMap((id) => this.store.select(selectPostById(id))),
        tap((post) => {
          this.videos = this.extractVideos(post);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  private extractVideos(
    post: Post | undefined,
  ): { href: string; type: string }[] {
    if (!post?.attachments) return [];

    return post.attachments
      .filter(
        (attachment) =>
          attachment.type === 'mp4' || attachment.type === 'video',
      )
      .map((attachment) => ({
        href: attachment.href,
        type: attachment.href.includes('youtube')
          ? 'video/youtube'
          : 'video/mp4',
      }));
  }
}
